import { render, staticRenderFns } from "./DiscoveryFilter.vue?vue&type=template&id=245c0fe6&"
import script from "./DiscoveryFilter.vue?vue&type=script&lang=js&"
export * from "./DiscoveryFilter.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryFilter.vue?vue&type=style&index=0&id=245c0fe6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports